import React from "react";

/**
 * Renders a location icon as an SVG element.
 *
 * @param {object} cls - The class name for styling the SVG.
 * @return {JSX.Element} The SVG element representing the location icon.
 */
export const LocationIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="marker 1">
        <g id="_01_align_center">
          <path
            id="Vector"
            d="M12 21.6004L11.4423 21.1224C10.6735 20.4786 3.96039 14.6809 3.96039 10.44C3.96039 5.99987 7.55987 2.40039 12 2.40039C16.4402 2.40039 20.0397 5.99987 20.0397 10.44C20.0397 14.6809 13.3265 20.4786 12.5609 21.1255L12 21.6004ZM12 4.13879C8.5216 4.14273 5.70277 6.96157 5.69883 10.44C5.69883 13.1042 9.829 17.3602 12 19.3082C14.1711 17.3594 18.3012 13.101 18.3012 10.44C18.2973 6.96157 15.4785 4.14277 12 4.13879Z"
            fill="currentColor"
          />
          <path
            id="Vector_2"
            d="M12 13.6276C10.24 13.6276 8.8132 12.2008 8.8132 10.4407C8.8132 8.68071 10.24 7.25391 12 7.25391C13.7601 7.25391 15.1869 8.68071 15.1869 10.4407C15.1869 12.2008 13.7601 13.6276 12 13.6276ZM12 8.84729C11.12 8.84729 10.4066 9.56069 10.4066 10.4407C10.4066 11.3207 11.12 12.0341 12 12.0341C12.8801 12.0341 13.5935 11.3207 13.5935 10.4407C13.5935 9.56069 12.8801 8.84729 12 8.84729Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
